import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Dropdown } from 'react-bootstrap';
import camelCaseRecursive from 'camelcase-keys-recursive';
import Icon from '../Icons';
import { indexHelpCategoriesRequest } from '../../requests/help';
import HelpSubcategoriesModal from './HelpSubcategoriesModal';
import ButtonTooltip from '../Utils/Tooltips/ButtonTooltip';

const HelpDropdown = () => {
  const dispatch = useDispatch();
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [modalShow, setModalShow] = useState(false);

  useEffect(() => {
    // Fetch categories on mount
    indexHelpCategoriesRequest({
      dispatch,
      successCallback: response => {
        // Assuming response structure based on typical API service `camelCaseRecursive` usage
        // response.data could be the array or wrapped in data property
        // The mock says API returns category list with subcategories.
        // Let's assume response.data is the list or response.data.data
        const data = camelCaseRecursive(response.data) || [];
        setCategories(data);
      },
      failureCallback: error => {
        console.error('Error fetching help categories:', error);
      }
    });
  }, [dispatch]);

  const handleCategoryClick = category => {
    setSelectedCategory(category);
    setModalShow(true);
  };

  return (
    <>
      <Dropdown alignRight className="notification">
        <Dropdown.Toggle as={ButtonTooltip} variant="circle-dark" className="btn-circle ml-3" text="Ayuda">
          <Icon icon="help-circle" />
        </Dropdown.Toggle>

        <Dropdown.Menu className="notifications t-r-0">
          {categories.length > 0 ? (
            categories.map(category => (
              <Dropdown.Item key={category.id} onClick={() => handleCategoryClick(category)}>
                {category.name}
              </Dropdown.Item>
            ))
          ) : (
            <Dropdown.Item disabled>No hay categorías disponibles</Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>

      <HelpSubcategoriesModal show={modalShow} onHide={() => setModalShow(false)} category={selectedCategory} />
    </>
  );
};

export default HelpDropdown;
